import {
  enumVersionPublicationStatus,
  searchFilterFilterType,
  searchOperator,
  type ApplicationVersionResourceListResponseV2Api,
  type ApplicationVersionResourceReadV2Api,
  type SearchApplicationVersionsV2MutationRequestApi,
  type SearchApplicationVersionsV2QueryParamsApi,
} from '@ingenico/api-sdk-device-management-private-v2';

export const APPLICATION_VERSIONS_SEARCH_PAGE_SIZE = 50;

export interface MapSearchApplicationVersionsRequestInput {
  readonly applicationId: string;
  readonly searchQuery?: string;
}

export function mapSearchApplicationVersionsRequest({
  applicationId,
  searchQuery,
}: MapSearchApplicationVersionsRequestInput): {
  readonly body: SearchApplicationVersionsV2MutationRequestApi;
  readonly params: SearchApplicationVersionsV2QueryParamsApi;
} {
  const applicationIdFilter: SearchApplicationVersionsV2MutationRequestApi['filters'] = [
    {
      filterType: searchFilterFilterType.string,
      name: 'applicationVersion.applicationId',
      operator: searchOperator.equals,
      value: applicationId,
    },
  ];
  const publishedStatusFilter: SearchApplicationVersionsV2MutationRequestApi['filters'] = [
    {
      filterType: searchFilterFilterType.array,
      name: 'applicationVersion.status',
      operator: searchOperator.in,
      value: JSON.stringify([enumVersionPublicationStatus.PUBLISHED]),
    },
  ];
  const fulltextFilter: SearchApplicationVersionsV2MutationRequestApi['filters'] = searchQuery
    ? [
        {
          filterType: searchFilterFilterType.fulltext,
          name: '',
          operator: searchOperator.equals,
          value: `*${searchQuery}*`,
        },
      ]
    : [];
  return {
    body: {
      filters: [...applicationIdFilter, ...publishedStatusFilter, ...fulltextFilter],
      sort: { field: 'applicationVersion.versionNumber', order: 'DESC' },
    },
    params: { offset: 0, limit: APPLICATION_VERSIONS_SEARCH_PAGE_SIZE },
  };
}

export function mapGetAllApplicationVersionIdsFromApplication({
  data,
}: ApplicationVersionResourceListResponseV2Api): string[] {
  return data?.map(({ id }: ApplicationVersionResourceReadV2Api) => id);
}
